import {
  MARKETS_FETCH,
  MARKETS_FETCH_SUCCESSFUL,
  MARKETS_FETCH_FAILED,
  UPDATE_FAVORITE,
  UPDATE_FAVORITE_SUCCESS,
  UPDATE_FAVORITE_FAIL,
  PRICING_FETCH,
  PRICING_FETCH_SUCCESSFUL,
  PRICING_FETCH_FAILED,
  MARKETS_FETCH_SPECIFIC,
  MARKETS_FETCH_SPECIFIC_FAILED,
  MARKETS_FETCH_SPECIFIC_SUCCESSFUL
} from './actionTypes'

export const fetchMarkets = (params = {}) => {
  return {
    type: MARKETS_FETCH,
    payload: params,
  }
}

export const fetchMarketsSuccessful = (markets) => {
  return {
    type: MARKETS_FETCH_SUCCESSFUL,
    payload: markets,
  }
}

export const fetchMarketsFailed = (markets) => {
  return {
    type: MARKETS_FETCH_FAILED,
    payload: markets,
  }
}
export const fetchSpecificMarket = (params = {}) => {
  return {
    type: MARKETS_FETCH_SPECIFIC,
    payload: params,
  }
}

export const fetchSpecificMarketSuccessful = (selectedMarket) => {
  return {
    type: MARKETS_FETCH_SPECIFIC_SUCCESSFUL,
    payload: selectedMarket,
  }
}

export const fetchSpecificMarketFailed = (markets) => {
  return {
    type: MARKETS_FETCH_SPECIFIC_FAILED,
    payload: markets,
  }
}
export const updateFevourite = (id, params = {}) => {
  return {
    type: UPDATE_FAVORITE,
    payload: {
      id,
      ...params,
    },
  }
}

export const updateFevouriteSuccess = (data) => {
  return {
    type: UPDATE_FAVORITE_SUCCESS,
    payload: data,
  }
}
export const updateFevouriteFail = (data) => {
  return {
    type: UPDATE_FAVORITE_FAIL,
    payload: data,
  }
}

export const fetchPricing = (markets) => {
  return {
    type: PRICING_FETCH,
    payload: markets,
  }
}

export const fetchPricingSuccessful = (pricingData) => {
  return {
    type: PRICING_FETCH_SUCCESSFUL,
    payload: pricingData,
  }
}

export const fetchPricingFailed = (error) => {
  return {
    type: PRICING_FETCH_FAILED,
    payload: error,
  }
}
